module.exports = __webpack_public_path__ + "static/img/srbczz_1.229f5202.png";